"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentOptionsModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _useConfig = _interopRequireDefault(require("../../../../hooks/useConfig"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _services = require("../../../../services");
var _utils = require("../../../../utils/utils");
var _core = require("@material-ui/core");
var _useLocalTheme = _interopRequireDefault(require("../../../../hooks/useLocalTheme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StyledModalImages = _styledComponents.default.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
`;
const StyledModal = _styledComponents.default.div``;
const PaymentImagesWrapper = _styledComponents.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const CloseButtonWrapper = _styledComponents.default.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
const PaymentOptionsModal = _ref => {
  let {
    isOpen,
    setIsOpen
  } = _ref;
  const paymentModalImages = (0, _useConfig.default)('paymentModal.images');
  const firstContainerImages = (0, _useConfig.default)('paymentModal.images.firstContainer');
  const showOnlyBanks = (0, _useConfig.default)('paymentModal.showOnlyBanks', false);
  const fullScreenMobile = (0, _useLocalTheme.default)('fullScreenMobile', false);
  const theme = (0, _core.useTheme)();
  const fullScreen = (0, _core.useMediaQuery)(theme.breakpoints.down('sm')) && fullScreenMobile;
  return /*#__PURE__*/_react.default.createElement(_core.Dialog, {
    className: "gs-app",
    open: isOpen,
    fullScreen: fullScreen,
    disableEnforceFocus: true,
    size: 'md',
    onClose: () => setIsOpen(false),
    style: {
      zIndex: '10000'
    },
    PaperProps: {
      style: {
        margin: 3,
        maxWidth: '680px'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_core.DialogContent, {
    style: {
      padding: '30px 40px'
    }
  }, /*#__PURE__*/_react.default.createElement(StyledModal, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    columns: {
      sm: 1
    },
    spacing: 3,
    verticalAlign: "center"
  }, /*#__PURE__*/_react.default.createElement(CloseButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.InteractiveIcon, {
    dataAttributes: {
      'data-test-id': 'overlay-button-close'
    },
    srText: "Close",
    name: "close",
    size: 4,
    appearance: "primary",
    onClick: () => setIsOpen(false)
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    appearance: "primary",
    state: "incomplete",
    highlight: {
      appearance: 'primary',
      level: 2
    },
    dataAttributes: {
      'data-test-id': 'payment-box-0'
    }
  }, showOnlyBanks ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    weight: 3,
    text: _services.locale.localeString('paymentModal.Headings.Title')
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: 2,
    text: _services.locale.localeString('paymentModal.Headings.h1')
  })) : /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    weight: 3
  }, _services.locale.localeString('paymentModal.Headings.h1')), firstContainerImages && /*#__PURE__*/_react.default.createElement(StyledModalImages, null, Object.keys(firstContainerImages).map(key => /*#__PURE__*/_react.default.createElement(PaymentImagesWrapper, {
    key: key
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: (0, _utils.getImagePath)(firstContainerImages[key]),
    style: {
      marginRight: '2px',
      height: '32px'
    }
  }))))), !showOnlyBanks && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    columns: {
      sm: 1,
      md: 2
    },
    spacing: 3,
    verticalAlign: "stretch"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    appearance: "primary",
    state: "incomplete",
    highlight: {
      appearance: 'primary',
      level: 2
    },
    dataAttributes: {
      'data-test-id': 'payment-box-1'
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    weight: 3
  }, _services.locale.localeString('paymentModal.Headings.h2')), /*#__PURE__*/_react.default.createElement("img", {
    src: (0, _utils.getImagePath)(paymentModalImages.banco),
    height: "32px"
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    appearance: "primary",
    state: "incomplete",
    highlight: {
      appearance: 'primary',
      level: 2
    },
    dataAttributes: {
      'data-test-id': 'payment-box-2'
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    weight: 3
  }, _services.locale.localeString('paymentModal.Headings.h3')), /*#__PURE__*/_react.default.createElement("img", {
    src: (0, _utils.getImagePath)(paymentModalImages.visa),
    style: {
      marginRight: '15px'
    },
    height: "32px"
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: (0, _utils.getImagePath)(paymentModalImages.mastercard),
    height: "32px"
  }))), !showOnlyBanks && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    appearance: "primary",
    state: "incomplete",
    highlight: {
      appearance: 'primary',
      level: 2
    },
    dataAttributes: {
      'data-test-id': 'payment-box-4'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    weight: 2
  }, _services.locale.localeString('paymentModal.Headings.h4')), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 1,
    weight: 2
  }, _services.locale.localeString('paymentModal.Headings.h5'))))))));
};
exports.PaymentOptionsModal = PaymentOptionsModal;